<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body pt-1">
        <div class="row pt-2">
          <div class="col-md-4">
            <h5 class="txt-blue">Quantitativo de serviços</h5>
          </div>

          <div class="col-md-6">
            <div class="btn-group d-flex">
              <button
                type="button"
                class="btn btn-light pl-2 pr-2 txt-gray" 
                (click)="retreatYear()"
              >
                <i class="fa fa-chevron-left"></i>
              </button>
              <button
                *ngFor="let ano of anos"
                type="button"
                class="btn"
                (click)="optionYear(ano)"
                [ngClass]="{
                  'btn-info': this.selectionYear == ano,
                  'btn-light': this.selectionYear != ano
                }"
              >
                {{ ano }}
              </button>

              <button
                type="button"
                class="btn btn-light pl-2 pr-2 txt-gray"
                (click)="forwardYear()"
                
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <div class="col-md-2">
            <button
                type="button"
                class="btn btn-block"
                (click)="changeNoZero()"
                [ngClass]="{
                  'btn-info': !this.noZero,
                  'btn-light': this.noZero
                }"
              >
                Exibir zeros
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <section
          class="animated fadeInDown h690"
          *ngIf="this.quantitativoServicos.length > 0"
        >
          <div class="row">
            <div class="col-md-12">
              <div
                class="box-table mb-3"
                style="min-height: 280px; max-height: 280px"
              >
                <table class="table-striped">
                  <thead>
                    <tr>
                      <th class="wf180 border-bold">Área</th>
                      <th class="border-bold wf180">Status</th>
                      <th class="wf90 border-bold">JAN</th>
                      <th class="wf90 border-bold">FEV</th>
                      <th class="wf90 border-bold">MAR</th>
                      <th class="wf90 border-bold">ABR</th>
                      <th class="wf90 border-bold">MAI</th>
                      <th class="wf90 border-bold">JUN</th>
                      <th class="wf90 border-bold">JUL</th>
                      <th class="wf90 border-bold">AGO</th>
                      <th class="wf90 border-bold">SET</th>
                      <th class="wf90 border-bold">OUT</th>
                      <th class="wf90 border-bold">NOV</th>
                      <th class="wf90 border-bold">DEZ</th>
                      <th class="wf180 border-bold">Acumulado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of this.quantitativoServicos;
                        let i = index
                      "
                    >
                      <td
                        class="text-center border-bold"
                        *ngIf="i % 4 == 0"
                        rowspan="4"
                      >
                        {{ item.areaTecnica }}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ item.status }}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.jan == 0 ? "" : item.jan.toLocaleString() :  item.jan.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.fev == 0 ? "" : item.fev.toLocaleString() :  item.fev.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.mar == 0 ? "" : item.mar.toLocaleString() :  item.mar.toLocaleString()}}

                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.abr == 0 ? "" : item.abr.toLocaleString() :  item.abr.toLocaleString()}}

                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.mai == 0 ? "" : item.mai.toLocaleString() :  item.mai.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.jun == 0 ? "" : item.jun.toLocaleString() :  item.jun.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.jul == 0 ? "" : item.jul.toLocaleString() :  item.jul.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.ago == 0 ? "" : item.ago.toLocaleString() :  item.ago.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.set == 0 ? "" : item.set.toLocaleString() :  item.set.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.out == 0 ? "" : item.out.toLocaleString() :  item.out.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.nov == 0 ? "" : item.nov.toLocaleString() :  item.nov.toLocaleString()}}
                      </td>
                      <td
                        class="text-center"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ this.noZero ? item.dez == 0 ? "" : item.dez.toLocaleString() :  item.dez.toLocaleString()}}
                      </td>
                      <td
                        class="text-center fb"
                        [ngClass]="{
                          'border-bold':
                            (i + 1) % 4 == 0 ||
                            i + 1 == this.quantitativoServicos.length
                        }"
                      >
                        {{ item.acumulado.toLocaleString() }}
                      </td>
                      <!-- *** -->
                    </tr>
                  </tbody>
                </table>
              </div>

              <section class="section-excel" >
                
                <div class="row">
                  
                  <div class="offset-md-5 col-md-4">
                    <section *ngIf="excelFileName !== ''" [class.highlight]="excelFileName !== ''">
                    <div class="col-md-4 text-center" >
                      <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile" >{{excelFileName}}</a>  
                    </div>
                  </section>
                  </div>
                  <div class="col-md-3">
                    <button type="button" 
                      class="btn btn-primary btn-block" 
                      title="Gera uma planilha Excel com os dados apresentados na grid"
                      (click)="exportarToExcel()"
                      >
                      <span class="pl-2 pr-2">Gerar planilha Excel</span>
                    </button>

                  </div>
                </div>
                
              </section>
            </div>
          </div>

          <div
            class="divider"
            style="
              border: 2px solid #ddd;
              margin-top: 10px;
              margin-bottom: 15px;
            "
          ></div>


          <div class="row mb-2">

            <div class="col-md-9" style="border-right: 1px solid #ddd;">
              <div class="row">
                <div class="col-md-3">
                  <div class="btn-group d-flex mt-2">
                    <button
                      type="button"
                      class="btn"
                      (click)="changeTipoResumo('status')"
                      title="Exibir resumo por Status"
                      [ngClass]="{
                        'btn-info': this.tipoResumo == 'status',
                        'btn-light': this.tipoResumo != 'status'
                      }"
                    >
                      <span class="fs09">Status</span>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      (click)="changeTipoResumo('area')"
                      title="Exibir resumo por Área técnica"
                      [ngClass]="{
                        'btn-info': this.tipoResumo == 'area',
                        'btn-light': this.tipoResumo != 'area'
                      }"
                    >
                      
                      <span class="fs09">Área</span>
                    </button>
                  </div>
                </div>

                <div class="col-md-9 months">

                  <div class="btn-group d-flex mt-2">
                    <button
                      type="button"
                      class="btn"
                      (click)="optionMonth(0)"
                      [ngClass]="{
                        'btn-info': this.selectionMonth == 0,
                        'btn-light': this.selectionMonth != 0
                      }"
                    >
                      <span class="fs08">Todos</span>
                    </button>

                    <button
                      *ngFor="let mes of meses"
                      type="button"
                      class="btn"
                      (click)="optionMonth(mes.numero)"
                      [ngClass]="{
                        'btn-info': this.selectionMonth == mes.numero,
                        'btn-light': this.selectionMonth != mes.numero
                      }"
                    >
                      <span class="fs08">{{ mes.nome_abrev }}</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" style="margin-bottom: 20px;">
                <div class="offset-md-3 col-md-7 text-center  pt-2">
                  Gráfico Resumo por {{this.tipoResumo == 'status' ? "Status" : "Área técnica"}} - 
                  {{this.selectionMonth > 0 ? this.meses[this.selectionMonth - 1].nome_abrev : ""}}  {{this.selectionYear}}
                </div>
                <div class="col-md-2 months">
                  <div class="btn-group d-flex mt-2">
                    <button
                      type="button"
                      class="btn"
                      (click)="changeTipoValoresGrafico('percentuais')"
                      title="Exibir resumo por Status"
                      [ngClass]="{
                        'btn-info': this.tipoValoresGrafico == 'percentuais',
                        'btn-light': this.tipoValoresGrafico != 'percentuais'
                      }"
                    >
                      <span class="fs09" title="valores percentuais"><i class="fa fa-percent" aria-hidden="true"></i></span>
                    </button>
                    <button
                      type="button"
                      class="btn"
                      (click)="changeTipoValoresGrafico('numericos')"
                      title="Exibir resumo por Área técnica"
                      [ngClass]="{
                        'btn-info': this.tipoValoresGrafico == 'numericos',
                        'btn-light': this.tipoValoresGrafico != 'numericos'
                      }"
                    >
                      
                      <span class="fs09" title="Valores numéricos"><i class="fa fa-bookmark" aria-hidden="true"></i></span>
                    </button>
                  </div>
                </div>

               
              </div>


              <div class="row" *ngIf="this.optionChartColumn != null">
                <div
                  class="col-md-12 mb-2 pl-0"
                  *ngIf="this.optionChartColumn != null"
                >
                  <div>
                    <apx-chart
                      [series]="optionChartColumn?.series"
                      [chart]="optionChartColumn?.chart"
                      [stroke]="optionChartColumn?.stroke"
                      [plotOptions]="optionChartColumn?.plotOptions"
                      [dataLabels]="optionChartColumn?.dataLabels"
                      [xaxis]="optionChartColumn?.xaxis"
                      [fill]="optionChartColumn?.fill"
                      [yaxis]="optionChartColumn?.yaxis"
                      [title]="optionChartColumn?.title"
                      [labels]="optionChartColumn?.labels"
                      [colors]="optionChartColumn?.colors"
                      [stroke]="optionChartColumn?.stroke"
                      [grid]="optionChartColumn?.grid"
                      [subtitle]="optionChartColumn?.subtitle"
                    >
                    </apx-chart>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              
              <div class="row">
                <div class="col-md-12 text-center txt-blue fb">
                  Quadro Resumo<br />por {{this.tipoResumo == 'status' ? "Status" : "Área técnica"}} - 
                  {{this.selectionMonth > 0 ? this.meses[this.selectionMonth - 1].nome_abrev : ""}}  {{this.selectionYear}}
                </div>
              </div>
              <div class="divider"></div>

                <div
                  class="box-table-sm"
                  style=" min-height: 175px; max-height: 175px; overflow: y;"
                >
                  <table class="table-striped fs09">
                    <thead *ngIf="this.tipoResumo === 'area'">
                    <tr>
                      <th>Area Téc.</th>
                      <th>Atend.</th>
                      <th>Não atend</th>
                      <th>Em and.</th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr *ngFor="let resumo of this.resumos">
                        <td style="width: 50%" [ngClass]="{
                          'text-center': this.tipoResumo === 'area',
                          'text-right': this.tipoResumo !== 'area'
                        }"  >
                          {{resumo.descricao}}
                        </td>
                        <td class="text-right">
                          <span class="pr-1">
                            {{resumo.valor.toLocaleString()}}</span>
                        </td>
                        <td class="text-right" *ngIf="this.tipoResumo === 'area'">
                          {{resumo.valor3.toLocaleString()}}
                        </td>
                        <td class="text-right" *ngIf="this.tipoResumo === 'area'">
                            {{resumo.valor2.toLocaleString()}}
                        </td>
                       
                      </tr>
                      
                  
                    </tbody>
                  </table>
                </div>

                <div class="box-table mt-1" style="overflow-y: hidden; height: 50px;">
                  <table class="fs09">
                    <tbody>
                      <tr>
                        <th style="background-color: #eee; width: 60%" class="fs11 text-center">Abertas</th>
                        <th class="fs11 text-right">{{this.totalResumo}}</th>
                      </tr>
                    </tbody>
                  </table>
    
                </div>

              

              
            </div>
          </div>
        </section>

        <section
          class="animated fadeInDown h670 text-center"
          *ngIf="this.quantitativoServicos.length  == 0"
        >
        <span class="material-icons" style="font-size: 20em; color: #f0f0f0; margin-top: 20px;" >
          grid_on
        </span><br />
        <span style="font-size: 1.2em; color: #808080">
         <span>Nenhum serviço encontrado no ano selecionado</span>
        </span>

      </section>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6 mb-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"
                ><img src="./assets/images/homePeq.png"
              /></a>
            </div>
          </div>
          <div class="col-md-3">
           
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
